import { SubscriptionPlan } from '@api/models/dashboard';

/**
 * Mock for the subscription plans catalog (physical store pricing).
 * V1 exposes a single plan; the UI reads the cheapest price from the list.
 */
export const listSubscriptionPlansMock = (): SubscriptionPlan[] => [
  { id: 'base-subscription-plan', label: 'Basic plan', price: 29, quota: 100 },
];
